import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { bootConsent } from './utils/consent/consent.client'

// Before Sentry and hydration: analytics vendors and session replay follow
// the visitor's cookie choices from the first moment.
bootConsent()

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client').then(({ init }) => init())
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
